import Vue from "vue";
// import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingFenceLeads: false,
      fenceRoLeads: [],
      fenceEuLeads: [],
    }),
    mutations: {
      setLoadingFenceLeads(state, item) {
        state.loadingFenceLeads = item
      },
      loadFenceLeads(state, payload) {
        const { items } = payload;
        
        if (items.length > 0) {
          items.forEach(function (item) {
            item.client_obj = JSON.parse(item.client_obj);
            item.prices = JSON.parse(item.prices);
            item.gard_obj = JSON.parse(item.gard_obj);
          });
        }

        if (payload.type === "ro") state.fenceRoLeads = items;
        else if (payload.type === "eu") state.fenceEuLeads = items;
      },
      updateInteresStatusFenceLead(state, payload) {
        const leadTypeOffers = payload.leadType == 'eu' ? 'fenceEuLeads' : 'fenceRoLeads'
        let idx = state[leadTypeOffers].findIndex(
          (obj) => obj.id_cerere == payload.id
        );
        state[leadTypeOffers][idx].interes = payload.interes;
        state[leadTypeOffers][idx].interes_details = payload.details;
      },
      markCalledFenceLead(state, payload) {
        const leadTypeOffers = payload.leadType == 'eu' ? 'fenceEuLeads' : 'fenceRoLeads'
        let idx = state[leadTypeOffers].findIndex(
          (obj) => obj.id_cerere == payload.id
        );
        state[leadTypeOffers][idx].called = payload.called;
        state[leadTypeOffers][idx].called_user_id = payload.user_id;
        state[leadTypeOffers][idx].called_user = payload.username;
        state[leadTypeOffers][idx].called_date = payload.called_date ? payload.called_date : payload.called == 0 ? null : new Date().toISOString();
      },
      markSentFenceLead(state, payload) {
        const leadTypeOffers = payload.leadType == 'eu' ? 'fenceEuLeads' : 'fenceRoLeads'
        let idx = state[leadTypeOffers].findIndex(
          (obj) => obj.id_cerere == payload.id
        );
        state[leadTypeOffers][idx].is_sent_oferta = payload.is_sent_oferta;
      },
    },
    actions: {
      async fetchFenceLeads({ commit, rootGetters }, { type, fromDate, toDate }) {
        commit("setLoadingFenceLeads", true);

        let url = process.env.VUE_APP_HUB_API_HOST + `api/manufacturing/leads/configurator/${type}`;

        const urlParams = {
          fromDate: fromDate,
          toDate: toDate,
        };

        const user = rootGetters.loggedUser;
        if (type === "ro" && (user.rol === "agent" || user.rol === "partener")) {
          urlParams["zone"] = user.zona;
        }
        
        try {
          const response = await Vue.http.get(url, {
            headers: headers,
            params: urlParams
          });
          commit("loadFenceLeads", { type: type, items: response.data });
          commit("setLoadingFenceLeads", false);
        } catch (error) {
          console.error("Error fetching fence leads:", error);
          throw error;
        }
      },
    }
}